<div class="content content--page">
  <div class="content__inner">
    <div class="content__main content__main--page">
      <div class="card">
        <h1 class="card__title">Messages</h1>
        <div class="card__content">
          <div class="notif notif--messages">
            @for (message of messages; track message.id) {
            <div class="notif-item" [ngClass]="{ 'notif-item--new': !message.dateViewed }">
              <div class="notif-item__date">{{ message.dateSent | date:'MMM dd, yyyy' }}</div>
              <div class="notif-item__text" [innerHTML]="message.content"></div>
            </div>
            }
          </div>
        </div>
        @if (loading) {
        <div class="loading-update">
          <div class="loading-update__loader loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
